// extracted by mini-css-extract-plugin
export default {"purveyotList":"purveyor_cadastre_list_purveyotList__O2tWM","Mui-focused":"purveyor_cadastre_list_Mui-focused__MDkQw","label":"purveyor_cadastre_list_label__BG3TY"};